import { styled } from '@uhg-abyss/web/tools/styled';

export const Styles: ReturnType<typeof styled> = styled('div', {
  '> div': {
    '> .abyss-tooltip-trigger': {
      height: '100%',
      width: '100%',
    },
    height: '100%',
    width: '100%',
  },
});
